module.exports = __webpack_public_path__ + "img/squash-dark.f8b3000f.svg";